/*
* Copyright (c) 2026 Send2Me, media capture and delivery platform. All rights reserved.
* Distributed under the TruVideo proprietary license.
*/
import PropTypes from 'prop-types';
import { WifiOff } from 'lucide-react';

// Compact corner pill instead of a full-width top bar — every capture
// screen anchors its brand logo at top-left, so a fixed full-width bar at
// top-0 was rendering directly over it. Anchoring small and top-right
// keeps it visible without ever covering the logo.
//
// Only ever shows the offline state — the "syncing" state is now covered by
// DataSyncOverlay's blocking overlay instead, so this stays quiet once back
// online rather than showing a redundant corner "Syncing N" pill.
const OfflineBanner = ({ isOnline, pendingSyncCount = 0 }) => {
  if (isOnline) return null;

  return (
    <div
      role="status"
      className="fixed right-3 z-[9998] flex items-center gap-1.5 px-3 py-1.5 rounded-full shadow-lg text-[11px] font-semibold bg-warning text-warning-content"
      style={{ top: 'max(0.75rem, env(safe-area-inset-top))' }}
    >
      <WifiOff size={12} className="shrink-0" />
      <span className="whitespace-nowrap">Offline{pendingSyncCount > 0 ? ` · ${pendingSyncCount}` : ''}</span>
    </div>
  );
};

OfflineBanner.propTypes = {
  isOnline: PropTypes.bool.isRequired,
  pendingSyncCount: PropTypes.number,
};

export default OfflineBanner;
